module.exports = __webpack_public_path__ + "media/images/lb/979-b5e4c5332aa075c739e33fada19b1c98.svg";